import ajaxService from './ajaxService';

export default {
  // 取得 Line UserId
  async getagentservice(param) {
    try {
      const queryString = new URLSearchParams(param).toString();
      const res = await ajaxService.post(`/mcs/get/api/v1/setting/agentservice?${queryString}`);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
};
